import React, {useMemo} from "react";
import {Select, SelectOptionProps} from "peggirkit";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {RestaurantLocation} from "@/data/entities/restaurant";
import SelectedLocationOption from "@widgets/layout/menu/LocationSelector/SelectedLocationOption";
import useAuth from "@/context/authentication/use-auth";

const LocationSelector = () => {
    const {mainRole} = useAuth();
    const {locations, dashboardLocation, setDashboardLocation} = useRestaurant();
    const options: SelectOptionProps<RestaurantLocation>[] = useMemo(() => {
        return locations.map((location: RestaurantLocation) => ({
            value: location.id,
            displayValue: location.name,
        }));
    }, [locations]);

    const value: SelectOptionProps<RestaurantLocation> | null = useMemo(() => {
        const result = options.filter(p => p.value === dashboardLocation.id);
        if (result.length === 0) {
            return null;
        }

        return result[0];
    }, [options, dashboardLocation]);

    return (
        <Select<RestaurantLocation>
            containerClassname={"group mb-4 -mt-2 -mx-2 !w-[calc(100%+1rem)]"}
            options={options}
            value={value}
            selectedComponent={SelectedLocationOption}
            displayValueEmpty={""}
            disabled={mainRole !== "ROLE_ADMIN"}
            onChange={(selectedOption: SelectOptionProps<RestaurantLocation>) => {
                if (selectedOption.value !== value?.value) {
                    setDashboardLocation(locations.filter(x => x.id === selectedOption.value)[0]);
                }
            }}
        />
    );
};

export default LocationSelector;